<template>
  <div class="employers text-center">
    <SideMenu
      v-if="showSideMenu"
      @close="showSideMenu = false"/>
    <TopMenu
      :title="$t('EMPLOYERS.PAGE_LABEL')"
      dark-background
      @menu="showSideMenu = true"/>
    <div class="container-fluid content">
      <TextSelector
        v-for="(employer, index) in selectedMemberEmployers"
        :key="index"
        :id="employer.id"
        :border-bottom="selectedMemberEmployers.length > 0 && index != selectedMemberEmployers.length - 1"
        @click="selectEmployer">{{ employer.companyName }}</TextSelector>
      <div class="actions">
        <ActionButton
          class="btn btn-lg btn-primary btn-block mt-3 mb-1"
          @click="$router.push('/dashboard/employers/add')">{{ $t("EMPLOYERS.ADD_EMPLOYERS_BUTTON") }}</ActionButton>
      </div>
    </div>
    <BottomMenu />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TextSelector from '@/components/Utils/TextSelector';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import TextLink from '@/components/Utils/TextLink';
import ActionButton from '@/components/Actions/ActionButton';
import SideMenu from '@/components/Menu/SideMenu';

export default {
  name: 'Employers',
  components: {
    ActionButton,
    TextLink,
    TopMenu,
    BottomMenu,
    SideMenu,
    TextSelector,
  },
  data() {
    return {
      showSideMenu: false,
    };
  },
  computed: {
    ...mapState('employer', ['selectedMemberEmployers']),
  },
  created() {
    this.$store.dispatch('employer/currentMemberEmployers');
  },
  methods: {
    selectEmployer(id) {
      if (id) {
        this.$router.push(`/dashboard/employers/${id}`);
      }
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.employers {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
  &.actions {
    text-align: right;
  }
}
</style>
